import currency from "currency.js";
import { logEvent } from "@/service/logs/log";

function prepareItem({ id, name, price, category, promotionPrice }) {
  const item = {
    item_id: id,
    item_name: name,
    item_category: category,
    price,
    quantity: 1,
  };

  if (promotionPrice) {
    item.discount = parseFloat(
      currency(price - promotionPrice, {
        decimal: ".",
        symbol: "",
      }).format(),
    );
  }

  return item;
}

export function triggerViewItem(item, logView: LogView) {
  const logData = {
    currency: "PLN",
    value: item.promotionPrice || item.price,
    items: [prepareItem(item)],
  };

  if (logView) {
    logEvent("ecommerce_view_item", logView, logData);
  }
}

export function triggerSelectItem(item, logView: LogView) {
  const logData = {
    currency: "PLN",
    value: item.promotionPrice || item.price,
    items: [prepareItem(item)],
  };

  if (logView) {
    logEvent("ecommerce_add_to_cart", logView, logData);
  }
}

export function triggerRemoveFromCart(
  { total, id, discount, omnibusPrice, product, name },
  logView: LogView,
) {
  const item = {
    item_id: id,
    item_name: product?.name ?? name,
    item_category: product?.details?.type ?? "package",
    price: parseFloat(omnibusPrice || total),
    quantity: 1,
  };

  if (discount) {
    item.discount = parseFloat(discount);
  }

  const logData = {
    currency: "PLN",
    value: parseFloat(total),
    items: [item],
  };

  if (logView) {
    logEvent("ecommerce_remove_from_cart", logView, logData);
  }
}
